<template>
  <div class="tip">
    商品已添加到购物车
  </div>
</template>

<script type="es6">
  export default {
    name: 'tip',
    methods: {
      closeBtn() {
        this.$emit('closetipbtn', false);
      }
    },
    created() {
      let time = 2;
      const self = this;
      const timer = setInterval(function () {
        time = --time;
        if (time < 1) {
          self.closeBtn();
          clearInterval(timer);
        }
      }, 1000);
    }
  }
</script>

<style lang="scss" scoped>
  .tip {
    position: fixed;
    top: 50%;
    left: 50%;
    background: rgba(0,0,0,.7);
    color: #fff;
    padding: 10px 20px;
    border-radius: 3px;
  }
</style>



// WEBPACK FOOTER //
// src/components/public-component/tip.vue